import "features/messages/src/styles/AdminPanel/index.scss";
import CloseAdminPanelButton from "./CloseAdminPanelButton";
import "features/messages/src/styles/_utils.scss";

export function AdminPanelHeader({ onClose, title }) {
  return (
    <div className="admin-panel__form-header">
      <div className="workspace-header__title workspace-header__block">{title}</div>
      <CloseAdminPanelButton onClick={onClose} />
    </div>
  );
}
